import Link from 'next/link';

import FormattedImage from '../FormattedImage/FormattedImage';

import styles from './LeafletSlide.module.scss';

export default function LeafletSlide({ _index, slide, leafletUrl, slug }) {
  const loading = _index === 0 ? 'eager' : 'lazy';

  return (
    <div key={_index} role="link" tabIndex="-1">
      <Link href={leafletUrl[_index] || `/${slug}`}>
        <a>
          <div className={styles.container}>
            <FormattedImage
              path={slide.path}
              alt={slide.text || 'προσφορά'}
              width={714}
              height={1100}
              loading={loading}
            />
          </div>
        </a>
      </Link>
    </div>
  );
}
